/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdvancedSearchHistoryDto } from '../../models/advanced-search-history-dto';

export interface MarkAdvancedSearchHistoryAsUsed$Params {
  searchId: number;
}

export function markAdvancedSearchHistoryAsUsed(
  http: HttpClient,
  rootUrl: string,
  params: MarkAdvancedSearchHistoryAsUsed$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AdvancedSearchHistoryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    markAdvancedSearchHistoryAsUsed.PATH,
    'post',
  );
  if (params) {
    rb.path('searchId', params.searchId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdvancedSearchHistoryDto>;
      }),
    );
}

markAdvancedSearchHistoryAsUsed.PATH =
  '/me/advanced-search-history/{searchId}/use';
